import Slider from './lib/slider';

export default class Hero {
    constructor(element) {
        this.element = element;

        /* This changes the slide selector to make the component work in pimcore editmode */
        let slideSelector = '.hero__slide';
        if(this.element.classList.contains('editmode')){
            slideSelector = '.pimcore_block_entry';
        }
        this.slider = new Slider(element, slideSelector);

        if(element.querySelectorAll('.hero__slide').length <= 1) {
            let controls = this.element.querySelector('.hero__controls');
            controls.parentElement.removeChild(controls);
            return;
        }

        this.initializeControls();
    }

    initializeControls() {
        this.nextControl = this.element.querySelector('button.next');

        this.nextControl.addEventListener('click', () => {
            this.slider.next();
        });

        this.previousControl = this.element.querySelector('button.previous');

        this.previousControl.addEventListener('click', () => {
            this.slider.previous();
        });
    }
}